var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-block-wrapper"},[_c('configuration-block'),_c('render-customing-block'),_c('specifications-block'),_c('beyond-photography-block'),_c('showcase-product-block'),_c('industries-block'),_c('customer-reviews-block')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }